import { Box, Checkbox, Skeleton as MuiSkeleton, TableCell, TableRow } from '@mui/material';

export default function Skeleton({ count, hasSelect = false }) {
    return Array(15)
        .fill({})
        .map((__, index) => (
            <TableRow key={index} data-cy="table-skeleton">
                {hasSelect && (
                    <TableCell sx={{ p: '12px 13px', borderBottom: index === 14 ? 'none' : '' }}>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Checkbox sx={{ p: 0 }} disabled />
                        </Box>
                    </TableCell>
                )}
                {Array(count)
                    .fill({})
                    .map((__, columnIndex) => (
                        <TableCell key={columnIndex} sx={{ p: 4, borderBottom: index === 14 ? 'none' : '' }}>
                            <MuiSkeleton sx={{ fontSize: '16px' }} />
                        </TableCell>
                    ))}
            </TableRow>
        ));
}
